import React from 'react'
import { ZdsTypography } from '@zera/components'

type UserNameProps = {
  username: string
}

export const UserName = ({ username }: UserNameProps): JSX.Element => {
  return <ZdsTypography variant="caption200">{username}</ZdsTypography>
}
